module.exports = __webpack_public_path__ + "img/home_newbie_act_pop_c.8646025c.png";